import React from 'react';
import { BrowserView, isMobile } from 'react-device-detect';
import { useParams } from 'react-router-dom';

import { AssistirMaisTardeBotao } from 'Component/AssistirMaisTarde';
import BotaoLink from 'Component/BotaoLink';
import Icone from 'Component/Icone';
import { ModuloLista } from 'Component/Modulo';
import Curso from 'Interface/Cursos';
import Matricula from 'Interface/Matriculas';
import { useRecuperarCursosQuery, useRecuperarMatriculasQuery } from 'Service';

const Visualizar = (): React.ReactElement => {
  const { slug = '' } = useParams();

  const { data: { cursos: [curso] } = { cursos: [{} as Curso] } } =
    useRecuperarCursosQuery({
      finder: 'slug',
      contain: ['Categorias', 'Modulos.Aulas.AulaConcluida', 'MaisTarde'],
      options: { slug: { slug: slug } },
    });
  const {
    data: { matriculas: [matricula] } = { matriculas: [{} as Matricula] },
  } = useRecuperarMatriculasQuery(
    {
      options: { curso_id: curso.id },
    },
    { skip: !curso.id }
  );

  return (
    <div className="animate__animated animate__fadeIn">
      <div
        className="hf-700 hf-sm-600 d-flex align-items-end"
        style={{
          backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 100%), url(${curso.imagem})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          marginTop: '-130px',
        }}
      >
        <div className="container px-4 px-sm-0 mb-5 pb-5">
          <h1
            className={[
              'text-white',
              !isMobile ? 'display-2' : 'display-4',
            ].class()}
          >
            <small className="d-block text-secondary fs-3 fw-bold">
              {curso.categoria?.nome}
            </small>
            {curso.nome?.cortar( !isMobile ? 65 : 50)}
          </h1>
          {curso.descricao ? (
            <p className="lead text-muted col-sm-8">
              {curso.descricao?.cortar(!isMobile ? 250 : 130)}
            </p>
          ) : (
            <React.Fragment>
              {curso.tecnologia == 'lti' ? (
                <p className="lead text-muted col-sm-8">
                  {'Ao acessar a plataforma de aprendizagem (AVA), você visualizará o curso e suas unidades de aprendizagem. Cada unidade de aprendizagem é composta por uma apresentação; um desafio para reflexão...'.cortar(
                    !isMobile ? 250 : 130
                  )}
                </p>
              ) : (
                <p className="lead text-muted col-sm-8">
                  {'O curso é composto por videoaulas elaboradas por profissionais altamente especializados, além de conter também um livro que pode ser baixado para estudar onde e quando quiser. Durante o curso, nossa plataforma permite'.cortar(
                    !isMobile ? 250 : 130
                  )}
                </p>
              )}
            </React.Fragment>
          )}
          <div className="d-flex flex-wrap gap-2">
            {matricula && matricula.proxima_aula_id ? (
              <BotaoLink
                lg
                to={`/estudar/curso/${curso.slug}/aula/${matricula.proxima_aula_id}`}
                icone="play-circle"
                tema="secondary"
              >
                Continuar
              </BotaoLink>
            ) : (
              <BotaoLink
                lg
                to={`/estudar/curso/${curso.slug}/aula/${
                  curso.modulos ? curso.modulos[0].aulas[0]?.id : null
                }`}
                icone="play-circle"
                tema="secondary"
              >
                Assistir agora
              </BotaoLink>
            )}{' '}
            <a
              href="#aulas"
              className="btn btn-outline-light btn-lg"
            >
              <Icone nome="chevron-down" className="me-2" />
              Ver aulas
            </a>{' '}
            <AssistirMaisTardeBotao
              tema="primary"
              cursoId={curso.id}
              dados={curso.mais_tarde}
            />
          </div>
        </div>
      </div>
      <div className="container mb-5 px-4 px-sm-0">
        <BrowserView>
          <div className="row align-items-center mb-5">
            <div className="col-6 col-md-3">
              <div className="fs-5 fw-light py-3 d-flex align-items-center">
                <Icone nome="book" className="me-3 text-secondary" />
                <span className="text-muted">{curso.total_aulas} aulas</span>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="fs-5 fw-light py-3 d-flex align-items-center">
                <Icone nome="clock" className="me-3 text-secondary" />
                <span className="text-muted">
                  Carga horária de {curso.carga_horaria}hrs
                </span>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="fs-5 fw-light py-3 d-flex align-items-center">
                <Icone nome="people" className="me-3 text-secondary" />
                <span className="text-muted">+500 alunos</span>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="fs-5 fw-light py-3 d-flex align-items-center">
                <Icone nome="patch-check" className="me-3 text-secondary" />
                <span className="text-muted">Certificado</span>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="fs-5 fw-light py-3 d-flex align-items-center">
                <Icone nome="display" className="me-3 text-secondary" />
                <span className="text-muted">100% online</span>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="fs-5 fw-light py-3 d-flex align-items-center">
                <Icone nome="calendar-check" className="me-3 text-secondary" />
                <span className="text-muted">Assista quando quiser</span>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="fs-5 fw-light py-3 d-flex align-items-center">
                <Icone nome="hand-thumbs-up" className="me-3 text-secondary" />
                <span className="text-muted">Credênciada pelo MEC</span>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="fs-5 fw-light py-3 d-flex align-items-center">
                <Icone nome="fire" className="me-3 text-secondary" />
                <span className="text-muted">Início imediato</span>
              </div>
            </div>
          </div>
        </BrowserView>

        <h2 id="aulas" className="fw-lighter fs-1 text-muted mt-0 mt-sm-0 mb-4">
          Aulas do curso
        </h2>
        {curso?.modulos?.map((modulo, chave) => (
          <ModuloLista
            key={`${modulo.id}-${modulo.modificado}`}
            dados={modulo}
            primeiro={!chave}
          />
        ))}

        <div className="row mt-5">
          <div className="col-md-12">
            <h2 className="fw-lighter fs-1 text-muted fw-light mb-4">
              Esse curso é voltado para quem?
            </h2>
            <p className="fs-5 text-white fw-light">{curso.publico_alvo}</p>
          </div>
          <div className="col-md-12">
            <h2 className="fw-lighter fs-1 text-muted fw-light mb-4">
              Qual é a metodologia?
            </h2>
            {curso.tecnologia == 'proprietaria' && (
              <p className="fs-5 text-white fw-light">
                O curso é composto por videoaulas elaboradas por profissionais
                altamente especializados, bem como materiais escritos que podem
                ser lidos quando e onde quiser. Você também pode realizar quizzes
                para testar os seus conhecimentos e acompanhar uma série conteúdos
                complementares para ampliar ainda mais o seu processo de ensino-aprendizagem.
                Para receber a certificação, deve ser feita uma avaliação com 5 questões
                de múltipla escolha, sendo o aluno aprovado caso acerte 70% das
                questões ou mais. É possível realizar a prova até 2 vezes.
              </p>
            )}
            {curso.tecnologia == 'lti' && (
              <p className="fs-5 text-white fw-light">
                Ao acessar a plataforma de aprendizagem (AVA), você visualizará
                o curso e suas unidades de aprendizagem. Cada unidade de
                aprendizagem é composta por uma apresentação; um desafio para
                reflexão sobre o conteúdo; um infográfico; um capítulo de livro;
                uma dica do professor, que poderá ser uma videoaula; 1 quiz com
                5 questões de múltipla escolha com o objetivo de promover melhor
                fixação de cada conteúdo; um caso de aplicação prática dos
                conteúdos; e, por fim, links para materiais complementares, que
                podem incluir textos e vídeos diversos. Observa-se que o desafio
                e o quiz não possuem caráter avaliativo, ou seja, não comporão
                sua nota para a certificação. Para você receber seu certificado,
                deverá realizar uma avaliação final com 10 questões de múltipla
                escolha, sendo necessário o acerto de 70% das questões ou mais
                para aprovação. Será possível realizar a prova até 2 vezes.
              </p>
            )}
            {curso.tecnologia == 'iesde' && (
              <p className="fs-5 text-white fw-light">
                O curso é composto por videoaulas elaboradas por profissionais
                altamente especializados, além de conter também um livro que
                pode ser baixado para estudar onde e quando quiser. Durante o
                curso, nossa plataforma permite fazer anotações digitais, bem
                como acompanhar seu progresso (percentual concluído em cada
                aula). Para receber a certificação, deve ser feita uma avaliação
                com 10 questões de múltipla escolha, sendo o aluno aprovado caso
                acerte 70% das questões ou mais. É possível realizar a prova até
                2 vezes.
              </p>
            )}
          </div>
        </div>

        {/* <h2 className="fw-lighter fs-1 text-muted fw-light mb-4 mt-5">
                    O que os alunos estão achando desse curso?
                </h2> */}

        {/* <Swiper
                    slidesPerView={ 3 }
                    centeredSlides={false}
                    spaceBetween={ 15 }
                    grabCursor={ true }
                    className="mySwiper"
                >
                    <SwiperSlide>
                        <div className="bg-dark rounded-3 p-4">
                            <p className="text-white fs-5 fw-light text-end">
                                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Repudiandae earum culpa voluptates tempora eos nihil dolore excepturi quia mollitia debitis assumenda similique voluptate amet, vel, saepe repellendus consequuntur suscipit dolorem?
                            </p>
                            <div className="d-flex justify-content-between align-items-center">
                                <img src="https://engenharia360.com/wp-content/uploads/2019/05/esta-pessoa-nao-existe-engenharia360-4.png" className="rounded-circle hf-50" alt="" />
                                <p className="text-secondary fs-3 text-end mb-0">
                                    John Doe
                                    <small className="d-block text-primary fs-6">
                                        Ribeirão Preto / SP
                                    </small>
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper> */}
      </div>
    </div>
  );
};

export default Visualizar;
